
<div>{{type.name}}</div>
